import React from "react";

export default function MovementConfirmation({ submittedData, onNewRequest, onViewHistory }) {
  const {
    transactionNumber,
    employeeDisplayName,
    employeeUPN,
    oldDepartment,
    newDepartment,
    oldJobTitle,
    newJobTitle,
    oldManager,
    newManager,
    oldLocation,
    newLocation,
    oldOffice,
    newOffice,
    status,
    actionLog,
    dateSubmitted,
  } = submittedData;

  const isSuccess = status === "Completed";

  const formattedSubmitted = dateSubmitted
    ? new Date(dateSubmitted).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" })
    : "—";

  function ReviewRow({ label, oldVal, newVal }) {
    const unchanged = oldVal === newVal;
    return (
      <div className={`review-row${unchanged ? " review-row-unchanged" : ""}`}>
        <span className="review-label">{label}</span>
        <span className="review-old">{oldVal || "—"}</span>
        <span className="review-arrow">→</span>
        <span className={`review-new${unchanged ? " review-unchanged-value" : ""}`}>
          {unchanged ? <span className="no-change-badge">No change</span> : (newVal || "—")}
        </span>
      </div>
    );
  }

  return (
    <div className="confirmation-page">
      <div className="confirmation-card" style={{ maxWidth: 640 }}>
        <div className="confirmation-icon">
          {isSuccess ? (
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
              <circle cx="28" cy="28" r="28" fill="#e6f4ea" />
              <path d="M18 28 L25 35 L38 21" stroke="#1e7e34" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          ) : (
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
              <circle cx="28" cy="28" r="28" fill="#fdecea" />
              <path d="M28 18v12M28 34h.01" stroke="#c0392b" strokeWidth="3" strokeLinecap="round" />
            </svg>
          )}
        </div>

        <h2>{isSuccess ? "Movement Completed" : "Movement Failed"}</h2>
        <p className="confirmation-subtitle">
          {isSuccess
            ? `The movement for ${employeeDisplayName} has been processed successfully.`
            : `The movement for ${employeeDisplayName} encountered an error. Review the action log below.`}
        </p>

        <div className="transaction-badge">
          <span className="transaction-label">Transaction Number</span>
          <span className="transaction-number">{transactionNumber}</span>
        </div>

        <div className="confirmation-details" style={{ textAlign: "left", marginTop: 24 }}>
          <div className="detail-row">
            <span className="detail-label">Employee</span>
            <span className="detail-value">{employeeDisplayName}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">UPN</span>
            <span className="detail-value">{employeeUPN}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Submitted</span>
            <span className="detail-value">{formattedSubmitted}</span>
          </div>
        </div>

        <div className="review-table" style={{ marginTop: 24 }}>
          <div className="review-header">
            <span className="review-label">Field</span>
            <span className="review-old">From</span>
            <span className="review-arrow" />
            <span className="review-new">To</span>
          </div>
          <ReviewRow label="Department" oldVal={oldDepartment} newVal={newDepartment} />
          <ReviewRow label="Job Title"  oldVal={oldJobTitle}   newVal={newJobTitle}   />
          <ReviewRow label="Manager"    oldVal={oldManager}    newVal={newManager}    />
          <ReviewRow label="Location"   oldVal={oldLocation}   newVal={newLocation}   />
          <ReviewRow label="Office"     oldVal={oldOffice}     newVal={newOffice}     />
        </div>

        {actionLog && (
          <div className="action-log" style={{ marginTop: 24 }}>
            <div className="action-log-label">Action Log</div>
            <pre className="action-log-content">{actionLog}</pre>
          </div>
        )}

        <div className="confirmation-actions">
          <button className="btn-secondary" onClick={onViewHistory}>View History</button>
          <button className="btn-primary" onClick={onNewRequest}>Submit Another Request</button>
        </div>
      </div>
    </div>
  );
}
